import { Typography, CircularProgress, Box } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducers";

export const Loading = () => {
  const { currentUser: user, loading: userLoading } = useSelector(
    (state: RootState) => state?.user
  );
  //navigate to dashboard if user is loaded
  // useEffect(() => {
  //   if (user && !userLoading) {
  //     window.location.href = "/dashboard";
  //   }
  // }, [user, userLoading]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{ mb: 2 }}
        role="progressbar"
        aria-label="Loading authentication status"
      />
      <Typography variant="h6" sx={{ color: "text.secondary" }}>
        Loading account information...
      </Typography>
    </Box>
  );
};
